import { all } from 'redux-saga/effects';

import practitionerSaga from './practitioner-saga';
import bookingSlotSaga from './bookingSlot-saga';

export default function* rootSaga() {
  yield all([practitionerSaga(), bookingSlotSaga()]);
}
